import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminComments from "@/pages/admin/AdminComments";

export const Route = createFileRoute("/admin/comments")({
  component: () => (
    <ProtectedRoute>
      <AdminComments />
    </ProtectedRoute>
  ),
});
